import { and, count, eq, journal_entry, type PowerSyncDrizzleDB } from "@journal/powersync";
import { liveJournalEntryFilters } from "./filters";

/**
 * SOFT_DELETE_STANDARD — count of a user's LIVE entries through the live layer
 * (the choke point). The auth flow's local-data probe (`checkUnsyncedActor` in
 * `auth/controllers.ts`) uses it to decide whether a visitor has data to migrate
 * before signing in/registering.
 *
 * Previously that probe read raw `journal_entry` filtering ONLY `user_id`, so
 * entries in the trash counted as "local data" and triggered the "keep data?"
 * prompt for already-deleted rows (the scattered-invariant bug). Going through
 * `liveJournalEntryFilters()` counts only live entries.
 */
export function getLiveJournalEntryCountForUserQuery(db: PowerSyncDrizzleDB, userId: string) {
  return db
    .select({ total: count() })
    .from(journal_entry)
    .where(and(eq(journal_entry.user_id, userId), ...liveJournalEntryFilters()));
}
